/*
if($(".hero-slider").length){

      $(".hero-slider").slick({
        slidesToShow: 1,
        infinite: true,
        arrow: false,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: false,
        nextArrow: false,
        cssEase: 'linear',
        fade: true
    
      });

}
*/
try{
if( $(".iconslider").length){
        $(".iconslider").slick({
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
   
    {
      breakpoint: 480,
      settings: {
         dots: true,
       
        
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
      });
}
if( $('.fadeslider').length){
  var $gallery = $('.fadeslider');
  var slideCount = null;

$gallery.on('init', function(event, slick){
  slideCount = slick.slideCount;
  console.log("slick is initialzied" + slick.slideCount );
  setSlideCount();
  setCurrentSlideNumber(slick.currentSlide);
});

$gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
  setCurrentSlideNumber(nextSlide);
});

    $gallery.slick({
      speed: 500,
      dots: true,
      infinite: true,
      fade: true,
      cssEase: 'linear',
      swipe: true,
      swipeToSlide: true,
      touchThreshold: 10,
      prevArrow: $('.msvimpctsldrprev'),
      nextArrow: $('.msvimpctsldrnext'),
    });



function setSlideCount() {
  var $el = $('.slide-count-wrap').find('.total');
  $el.text('0'+slideCount);
}

function setCurrentSlideNumber(currentSlide) {
  var $el = $('.slide-count-wrap').find('.current');
  var current_slide = currentSlide + 1;
  $el.text('0'+current_slide);
}

}
}
catch(e){
  
}

if($(".gallery.scroll-snap").length && $(window).width() < 768){

      $(".gallery.scroll-snap").slick({
        lazyLoad: 'progressive',
        slidesToShow: 1,
        infinite: true,
        dots: true,
        arrow: false,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        prevArrow: false,
        nextArrow: false,
         speed:300,
       useTransform: false,
    
      });
    

}


console.log(`ready for you may also like ${$(".y-m-like").length}`);

const observer_cr = new MutationObserver(() => {
  document.querySelectorAll('.option').forEach(option => {
    if (
      option.dataset.value === 'QAR' &&
      option.textContent.includes('Qatari Rial')
    ) {
      option.innerHTML = option.innerHTML.replace('Qatari Rial', 'Qatari Riyal');
    }
  });
});

observer_cr.observe(document.body, {
  childList: true,
  subtree: true
});

/*

function styleTabby(myComp, attempt = 0) {
    if (!myComp) return;

    const shadow = myComp.shadowRoot;
    if (!shadow) {
        if (attempt < 10) { // try 10 times max
            setTimeout(() => styleTabby(myComp, attempt + 1), 100);
        }
        return;
    }

    const titled = shadow.querySelector('.styles__tabbyPromoSnippetText--b30d0');
    const ex_ft = shadow.querySelector('.styles__message--bea27');

    if (titled && ex_ft) {
        console.log('Tabby styling now applied!');
        ex_ft.style.setProperty('font-family', 'NHaasGroteskDSPro55Rg', 'important');
        ex_ft.style.setProperty('font-size', '12px', 'important');
        ex_ft.style.setProperty('text-transform', 'uppercase', 'important');
    } else {
        if (attempt < 10) {
            setTimeout(() => styleTabby(myComp, attempt + 1), 100);
        }
    }
}
var MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
    domChangeCallback = function(mutations) {
        mutations.forEach(function(mutation) {
          console.log(performance.navigation.type);
          try{
          
            if ($('.styles__containerPortal--c9f84').length ) {
                console.log('tabby section is injected');
               
               const myComp = document.querySelector('.styles__containerPortal--c9f84');
              styleTabby(myComp);
            //  const shadow = myComp.shadowRoot;
             // const titled = shadow.querySelector('.styles__tabbyPromoSnippetText--b30d0');
              //titled.style.fontFamily  = 'NHaasGroteskDSPro55Rg';
              //titled.style.fontSize   = '12px';
              //titled.style.textTransform = 'uppercase';
             // titled.style.setProperty('font-family', 'NHaasGroteskDSPro55Rg', 'important');
             //  titled.style.setProperty('font-size', '12px', 'important');
             //  titled.style.setProperty('text-transform', 'uppercase', 'important');
              
           //   const ex_ft = shadow.querySelector('.styles__message--bea27');
              //ex_ft.style.fontFamily  = 'NHaasGroteskDSPro55Rg';
              //ex_ft.style.fontSize   = '12px';
              //ex_ft.style.textTransform = 'uppercase';
            //    ex_ft.style.setProperty('font-family', 'NHaasGroteskDSPro55Rg', 'important');
             //  ex_ft.style.setProperty('font-size', '12px', 'important');
             //  ex_ft.style.setProperty('text-transform', 'uppercase', 'important');
            }

if ($('#tamara-widget-custom').length ) {
                console.log('tamara section is injected');
               
               const myComp_t = document.querySelector('#tamara-widget-custom');
              const shadow_t = myComp_t.shadowRoot;
              const titled_t = shadow_t.querySelector('.tamara-summary-widget__container');
             // titled_t.style.fontFamily  = 'NHaasGroteskDSPro55Rg';
              //titled_t.style.fontSize   = '12px';
  //titled_t.style.textTransform = 'uppercase';
   titled_t.style.setProperty('font-family', 'NHaasGroteskDSPro55Rg', 'important');
               titled_t.style.setProperty('font-size', '12px', 'important');
               titled_t.style.setProperty('text-transform', 'uppercase', 'important');
            } 
          }
          catch(e){
            
          }

        });
    },
    observer = new MutationObserver(domChangeCallback);

var domElement = $('body')[0];

observer.observe(domElement, {
    characterData: false,
    attributes: false,
    childList: true,
    subtree: false
});

*/

$(document).on('click','ul.v-swatch.color-option li:not(.active)', function(e){
  console.log("clicked");
  let wrapper_div = $(this).closest('.product-grid-listing');
  var img_src = $(this).data("image");
  var color =   $(this).data("color");
  wrapper_div.find("img").attr("src",img_src);
  wrapper_div.find("img").attr("srcset",img_src);
 
  wrapper_div.find("ul.v-swatch.color-option li").removeClass("active");
  $(this).addClass("active");
  
 /* var prod_id = $(this).data("id");
  var variants_data = JSON.parse(wrapper_div.find(`#ProductJson-${prod_id}`).text());
  console.log(variants_data);
  var sizes_html = '';
  variants_data.forEach(variant => {
    console.log(variant.available);
    var is_available = (variant.available) ? 'available' : 'size-oos';
    var val_pos = "option" + variant.options.length;
    sizes_html += `<li class ="${is_available}" data-v-id="${variant.id}" >${variant[val_pos]}</li>`;
  });
  console.log(sizes_html);  
  wrapper_div.find("ul.v-swatch.size-option").html(sizes_html);
   wrapper_div.find("ul.mob-sizes").html(sizes_html);
  wrapper_div.find('.size-error').addClass("hidden");*/
  if(color){
    color =  "IN "+ color;
    color = color.toUpperCase().trim();
    wrapper_div.find(".color-in").text(color);
  }
  
});


$(document).on('click','ul.v-swatch.size-option li', function(e){

  let wrapper_div = $(this).closest('.product-grid-listing');
  wrapper_div.find("ul.v-swatch.size-option li").removeClass("active");
  $(this).addClass("active");
  wrapper_div.find('.size-error').addClass("hidden");
  wrapper_div.find(".selected_variant").val($(this).data("v-id"));
  if($(this).hasClass("size-oos")){
    wrapper_div.find('button.cartButton.is-primary.plp').attr('disabled', true)
    wrapper_div.find('button.cartButton.is-primary.plp .cartPriceAdd flex c').text('Sold Out');
   
  }
  else{
     wrapper_div.find('button.cartButton.is-primary.plp').attr('disabled', false);
     wrapper_div.find('button.cartButton.is-primary.plp .cartPriceAdd flex c').text('Add to cart');
  }
  
});

$(document).on('click','ul.mob-sizes li', function(e){

  let wrapper_div = $(this).closest('.product-grid-listing');
  wrapper_div.find("ul.mob-sizes li").removeClass("active");
  $(this).addClass("active");
  wrapper_div.find(".selected_variant").val($(this).data("v-id"));
  if($(this).hasClass("size-oos")){
    wrapper_div.find('button.cartButton.is-primary.plp').attr('disabled', true)
    wrapper_div.find('button.cartButton.is-primary.plp .cartPriceAdd flex c').text('Sold Out');
   
  }
  else{
     wrapper_div.find('button.cartButton.is-primary.plp').attr('disabled', false);
     wrapper_div.find('button.cartButton.is-primary.plp .cartPriceAdd flex c').text('Add to cart');
  }
   if(!$(this).hasClass("size-oos")){
        wrapper_div.find('button.cartButton.is-primary.plp').click();
   }
  
});
$(document).on('click','.product-page button.cartButton.is-primary', function(e){
  let wrapper_div = $(this).closest('.product-page');
  var variant_id = wrapper_div.find(".atc-v-id").val();
  if(variant_id){
      $(this).addClass("loading");
       add_to_cart(parseInt(variant_id) , '' , $(this) );
  }

});
$(document).on('click','.product-grid-listing button.cartButton.is-primary.plp', function(e){
  var device = ($(window).width() < 768) ? 'mobile' : 'desktop' ; 
  let wrapper_div = $(this).closest('.product-grid-listing');
  if( device == 'desktop' ){
    if( !wrapper_div.find("ul.v-swatch.size-option li").hasClass("active") ){
      e.preventDefault();   
      wrapper_div.find('.size-error').removeClass("hidden");
      
    }
    else{
      $(this).addClass("loading");
      add_to_cart(parseInt(wrapper_div.find("ul.v-swatch.size-option li.active").data("v-id")) , wrapper_div , $(this) );
    }
  }

  if( device == 'mobile' ){
    if( !wrapper_div.find("ul.mob-sizes li").hasClass("active") ){
      e.preventDefault();   
      wrapper_div.find(".size-popup-mini").toggleClass("active");
    }
    else{
      $(this).addClass("loading");
       wrapper_div.find(".size-popup-mini").removeClass("active");
       add_to_cart(parseInt(wrapper_div.find("ul.mob-sizes li.active").data("v-id")) , wrapper_div , $(this) );
    }
  }
  

  
});
function add_to_cart(variant_id , parent_el , cur_el){
  $.ajax({
      url: '/cart/add.js',
      data: {
        id: variant_id,
        quantity: 1,
        
      },
      dataType:"json",
      type: 'POST',
      success: function (res) {
        if(parent_el){
          parent_el.find("ul.mob-sizes li.active").removeClass("active");
          parent_el.find("ul.v-swatch.size-option li.active").removeClass("active");
        }  
        cur_el.removeClass("loading");
        console.log(res);
        show_popup(res , 0);
        
      console.log(res)
      },
     error: function (error) {
      if(parent_el){
        parent_el.find("ul.mob-sizes li.active").removeClass("active");
        parent_el.find("ul.v-swatch.size-option li.active").removeClass("active");
      }
      cur_el.removeClass("loading");
      alert(error.responseJSON.description);
       
      },
    
    });
}


 async function show_popup(added_item , total_items) {
  console.log(added_item);
   // var full_cart = await CartJS.getCart();
  //  var item_count =  full_cart.responseJSON.item_count;
    $.ajax({
      url: '/cart.js',
      dataType:"json",
      type: 'GET',
      success: function (res) {
      
      console.log(res);
        let items_html = `<div class="wrap-mini-crt">`;
        for(item in res.items){
          console.log(item);
          added_item = res.items[item];
            let a_color = (added_item.variant_options.length) ? 'In '+added_item.variant_options[0] : '';
        let a_size = (added_item.variant_options.length > 1) ? added_item.variant_options[1] : '';
          items_html += `<div class="cn-product"> <div class="cn-product-image"> <img src="${added_item.featured_image.url}" alt="" loading="lazy"> </div> <div class="cn-details"> <h3 class="cn-product-name">${added_item.product_title}</h3> <p class="cn-product-variant">${a_color}</p> <p class="cn-product-size">${a_size}</p> <p class="cn-product-qty">Quantity: ${added_item.quantity}</p> <p class="cn-product-price"> <span class="money">${Shopify.formatMoney(added_item.final_line_price,"Dhs. {{amount}}")} </span> </p> <a href="#" data-mini-v-id=${added_item.key} class="remove-crt">Remove</a> </div></div>`;
        }
          items_html +=`</div>`;
        $('.carto .visually-hidden').text("("+res.item_count+")");
        
      
        
        var item_html =`<div class="min-cart-wrap"><div class="cn-header ss"> <h2 class="cn-heading">${res.item_count} ITEM(S)</h2> <span class="cn-close"> ${Shopify.formatMoney(res.total_price,"Dhs. {{amount}}")} </span> </div> <div class="cn-header tt"> <h2 class="cn-heading" style=" font-size: 11px; ">SUBTOTAL</h2> <span class="cn-close">${Shopify.formatMoney(res.total_price,"Dhs. {{amount}}")}  </span> </div>${items_html} <a href="/checkout" class="create-account-btn cart1">Continue</a><a href="/collections/all" class="create-account-btn">Continue Shopping</a><div class="payment-sp-icons"> <img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_5.svg?v=1747308093" class="vis-ic"> <img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_6.svg?v=1747308093" class="mstr-ic"><img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_8.svg?v=1747320314" class="apple-ic"> <img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_7.svg?v=1747308093" class="tby-ic"> <img src="https://cdn.tamara.co/widget-v2/assets/tamara-grad-en.ac5bf912.svg" class="tmr-ic"> </div></div>`;
        console.log(item_html);
        document.querySelectorAll('.min-cart-wrap').forEach(el => el.remove());
         document.querySelectorAll('.empt-cart-head').forEach(el => el.remove());
document.querySelectorAll('.cart-popup .cn-header.mpt-target').forEach(item => {
    item.insertAdjacentHTML('afterend', item_html);
});
         if( window.innerWidth < 750){
      var popup_cart =  document.getElementById('mb-popup-cart');
      popup_cart.classList.add('show_mobile_cart');
    }
       
      }
      });
   
 
}

async function update_popup(cartData) {
       let res = cartData;
        let added_item =  cartData.items[0];
   let items_html = `<div class="wrap-mini-crt">`;
        for(item in cartData.items){
          console.log(item);
          added_item = res.items[item];
            let a_color = (added_item.variant_options.length) ? 'IN '+added_item.variant_options[0] : '';
        let a_size = (added_item.variant_options.length > 1) ? added_item.variant_options[1] : '';
          items_html += `<div class="cn-product"> <div class="cn-product-image"> <img src="${added_item.featured_image.url}" alt="" loading="lazy"> </div> <div class="cn-details"> <h3 class="cn-product-name">${added_item.product_title}</h3> <p class="cn-product-variant">${a_color}</p> <p class="cn-product-size">${a_size}</p> <p class="cn-product-qty">Quantity: ${added_item.quantity}</p> <p class="cn-product-price"> <span class="money">${Shopify.formatMoney(added_item.final_line_price,"Dhs. {{amount}}")} </span> </p> <a href="#" data-mini-v-id=${added_item.key} class="remove-crt">Remove</a> </div></div>`;
        }
          items_html +=`</div>`;
       
        $('.carto .visually-hidden').text("("+res.item_count+")");
        
        
        var item_html =`<div class="min-cart-wrap"><div class="cn-header ss"> <h2 class="cn-heading">${res.item_count}ITEM(S)</h2> <span class="cn-close"> ${Shopify.formatMoney(res.total_price,"Dhs. {{amount}}")} </span> </div> <div class="cn-header tt"> <h2 class="cn-heading" style=" font-size: 11px; ">SUBTOTAL</h2> <span class="cn-close">${Shopify.formatMoney(res.total_price,"Dhs. {{amount}}")}  </span> </div> ${items_html}<a href="/checkout" class="create-account-btn cart1">Continue</a><a href="/collections/all" class="create-account-btn">Continue Shopping</a><div class="payment-sp-icons"> <img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_5.svg?v=1747308093" class="vis-ic"> <img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_6.svg?v=1747308093" class="mstr-ic"> <img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_8.svg?v=1747320314" class="apple-ic"><img src="https://cdn.shopify.com/s/files/1/0650/5411/3834/files/svgviewer-output_7.svg?v=1747308093" class="tby-ic"> <img src="https://cdn.tamara.co/widget-v2/assets/tamara-grad-en.ac5bf912.svg" class="tmr-ic"> </div></div>`;
        console.log(item_html);
        document.querySelectorAll('.min-cart-wrap').forEach(el => el.remove());
document.querySelectorAll('.cart-popup .cn-header.mpt-target').forEach(item => {
    item.insertAdjacentHTML('afterend', item_html);
});
        
}
$(document).on('click','.remove-crt', function(e){
   e.preventDefault(); 
 
  $.ajax({
      url: '/cart/change.js',
      data: {
        id: $(this).data('mini-v-id'),
        quantity: 0,
        
      },
      dataType:"json",
      type: 'POST',
      success: function (res) {
        
        
      console.log(res);
        if(res.items.length){
          update_popup(res);
        }
        else{
          document.querySelectorAll('.min-cart-wrap').forEach(el => el.remove());
          document.querySelectorAll('.empt-cart-head').forEach(el => el.remove());
          document.querySelectorAll('.cart-popup .cn-header.mpt-target').forEach(item => {
    item.insertAdjacentHTML('afterend', '<p class="empt-cart-head">Your Bag Is Empty</p>');
             $('.carto .visually-hidden').text("(0)");
});
        }
      },
     error: function (error) {
     
      alert(error.responseJSON.description);
       
      },
    
    });
});

   $(".noticer").slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1
      });


$(document).on('click','a', function(e){
  
 console.log('clicked on a');
  console.log($(this).attr('href'));
  
  try{
    var anchor_link = $(this).attr('href');
  if(anchor_link.includes("/") || anchor_link.includes("/collections") || anchor_link.includes("/product") ){
   // $('body').addClass("mi-fp-loader");
  }
  }
  catch(e){
    
  }
  
});





$(document).on('click','.pdp-related-color', function(e){
  
  window.location.href = $(this).data("handle");
  
});
  $('.size-option.pdp label').on('click', function(){
    console.log($(this).data("qty"));
    var v_qty = parseInt($(this).data("qty"));
    if(v_qty > 5){
      $('.product-stock .icon-inventory').removeClass("limited");
      $('.product-stock .icon-inventory').removeClass("out-of-stock");
      $('.product-stock .mx-1').text("In Stock");
    }
    else if(v_qty < 5 && v_qty != 0){
      $('.product-stock .icon-inventory').addClass("limited");
      $('.product-stock .icon-inventory').removeClass("out-of-stock");
      $('.product-stock .mx-1').text("Limited Stock");
    }
    else if(v_qty <= 0){
      $('.product-stock .icon-inventory').removeClass("limited");
      $('.product-stock .icon-inventory').addClass("out-of-stock");
      $('.product-stock .mx-1').text("Out Of Stock");
    }
})
 //  window.addEventListener('load', (event) => {
 //    (function($) {
 //      $(function() {
 //        console.log( "document ready!" );

 //        var $sticky = $('.galleria-sticky');
 //        var $stickyrStopper = $('.galleria-sticky-disable');
 //        var $containerWidth = $('#prodesc').width();

 //        console.log("$sticky " + $sticky);
 //        console.log("$stickyrStopper " + $stickyrStopper);
 //        console.log("$containerWidth " + $containerWidth);
 //        if (!!$sticky.offset()) { // make sure ".galleria-sticky" element exists

 //          var generalSidebarHeight = $sticky.innerHeight();
 //          var stickyTop = $sticky.offset().top;
 //          var stickOffset = 0;
 //          var stickyStopperPosition = $stickyrStopper.offset().top;
 //          var stopPoint = generalSidebarHeight - stickyStopperPosition   - stickOffset;
 //          var diff = stopPoint + stickOffset;

 //          $(window).scroll(function(){ // scroll event
 //            var windowTop = $(window).scrollTop(); // returns number
 //            console.log("windowtop: "+windowTop)
 // console.log("stopPoint: "+stopPoint)
 //            if (stopPoint < windowTop) {
 //              $('#prodesc').css({ position: 'static', top: diff });
 //              console.log('set absolute');
 //            } else if (stickyTop < windowTop+stickOffset) {
 //              $('#prodesc').css({ position: 'fixed', top: '110px', right:'14px' });
 //               console.log('set fixed')
 //            } else {
 //              $('#prodesc').css({position: 'static', top: 'initial'});
 //               console.log('set absolute with top initial');
 //            }
 //          });

 //        }
 //      });
 //    })(jQuery);
 //  });





// const contentArea = document.querySelector('.gallery')
// const sideBar = document.querySelector('#prodesc')

// // run function on load, scroll and resize for better performance
// window.onload = () => controlSideBarFloating()
// window.onscroll = () => controlSideBarFloating()
// window.onresize = () => controlSideBarFloating()

// // lets define some variables
// var leftBlock = contentArea
// var rightBlock = sideBar
// var topSpace = 10
// var breakpoint = 992  // we use 992 for col-lg
// var stickyClass = 'sticky-sidebar'
// var bottomFixedClass = 'bottom-fixed-sidebar'

// // now create a function that will create sticky sidebar and use above variables
// function controlSideBarFloating(){
//     var rectL = leftBlock.getBoundingClientRect();
//     var rectR = rightBlock.getBoundingClientRect();
//     if(window.innerWidth >= breakpoint){
//         if(rectL.top-topSpace + (rectL.height - rectR.height) >= 0 && rectL.top-topSpace <= 0){
//             rightBlock.classList.add(stickyClass)
//             rightBlock.classList.remove(bottomFixedClass)
//         }else if(rectL.top-topSpace + (rectL.height - rectR.height) <= 0){
//             rightBlock.classList.remove(stickyClass)
//             rightBlock.classList.add(bottomFixedClass)
//         }else{
//             rightBlock.classList.remove(stickyClass)
//             rightBlock.classList.remove(bottomFixedClass)
//         }
//     }else{
//         rightBlock.classList.remove(stickyClass)
//         rightBlock.classList.remove(bottomFixedClass)
//     }
// }


// $(document).ready(function() {
//   $.stickysidebarscroll("#shopify-section-footer",{offset: {top: 10, bottom: 200}});
// });


// $(document).ready(function() {
//   var $window = $(window);  
//   var $sidebar = $("#prodesc"); 
//   var $sidebarHeight = $sidebar.innerHeight();   
//   var $footerOffsetTop = $("#shopify-section-footer").offset().top; 
//   var $sidebarOffset = $sidebar.offset();
  
//   $window.scroll(function() {
//     if($window.scrollTop() > $sidebarOffset.top) {
//       $sidebar.addClass("mfixed");   
//     } else {
//       $sidebar.removeClass("mfixed");   
//     }    
//     if($window.scrollTop() + $sidebarHeight > $footerOffsetTop) {
//       $sidebar.css({"top" : -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});        
//     } else {
//       $sidebar.css({"top": "0",});  
//     }    
//   });   

  
// });



// var stickitLeft = $('#prodesc').offset.left;
// var stickitWidth = $('#prodesc').width() + 'px';
// var stickitHeight = $('#prodesc').height() + 'px';
// var stickySidebarToTop = $('#prodesc').offset().top;
// $(window).scroll(function() {
//   var windowToTop = $(window).scrollTop();
//   if (windowToTop + 10 > stickySidebarToTop) {
//     $('#prodesc').css({
//       'position': 'fixed',
//       'top': '10px',
//       'right': '0',
//       'left': stickitLeft,
//       'width': stickitWidth,
//       'height': stickitHeight
//     })
//   } else {
//     $('#prodesc').removeAttr('style');
//   }
// })



// var a = new StickySidebar('#prodesc', {
// 			topSpacing: 20,
// 			bottomSpacing: 20,
// 			containerSelector: '.product-page',
// 			innerWrapperSelector: '.galleria-sticky'
// 		});


// $(function() {
//     var top = $('#prodesc').offset().top - parseFloat($('#prodesc').css('marginTop').replace(/auto/, 0));
//     var footTop = $('footer').offset().top - parseFloat($('footer').css('marginTop').replace(/auto/, 0));

//     var maxY = footTop - $('#prodesc').outerHeight();

//     $(window).scroll(function(evt) {
//         var y = $(this).scrollTop();
//         if (y > top) {
            
// //Quand scroll, ajoute une classe ".fixed" et supprime le Css existant 
//             if (y < maxY) {
//                 $('#prodesc').addClass('mfixed').removeAttr('style');
//             } else {
                
// //Quand la prodesc arrive au footer, supprime la classe "fixed" précèdement ajouté
//                 $('#prodesc').removeClass('mfixed').css({
//                     position: 'absolute',
//                     top: (maxY - top) + 'px'
//                 });
//             }
//         } else {
//             $('#prodesc').removeClass('mfixed');
//         }
//     });
// });



// Cache our vars for the fixed sidebar on scroll
  //  var $sidebar = $('#prodesc');
    // Get & Store the original top of our #sidebar-nav so we can test against it
    // var sidebarTop = $sidebar.position().top;
    // Edit the `- 10` to control when it should disappear when the footer is hit.
    // var blogHeight = $('.galleria-sticky-disable').offset().top + 10 ;

    // Add the function below to the scroll event
   // $(window).scroll(fixSidebarOnScroll);

    // On window scroll, this fn is called (binded above)
   // function fixSidebarOnScroll() {
        // Cache our scroll top position (our current scroll position)
     //   var windowScrollTop = $(window).scrollTop();

        // Add or remove our sticky class on these conditions
    //    if (windowScrollTop >= blogHeight || windowScrollTop <= sidebarTop) {
            // Remove when the scroll is greater than our #content.OuterHeight()
            // or when our sticky scroll is above the original position of the sidebar
      //      $sidebar.removeClass('mfixed');
       // }
        // Scroll is past the original position of sidebar
  //      else if (windowScrollTop >= sidebarTop) {
            // Otherwise add the sticky if $sidebar doesnt have it already!
   //         if (!$sidebar.hasClass('mfixed')) {
  //              $sidebar.addClass('mfixed');
   //         }
   //     }
   // }
window.addEventListener('beforeunload', function (e) {
 // $('body').addClass("mi-fp-loader");
  // the absence of a returnValue property on the event will guarantee the browser unload happens
 console.log(e);
}); 

  $(window).on('beforeunload', function(){
   
     // $('body').addClass("mi-fp-loader");
   
    //  console.log("beforeUnload event!");
    
     
  });
$(window).on('unload', function(){
   
    //  $('body').removeClass("mi-fp-loader");
   //   console.log("beforeUnload event!");
    
     
  });
$(document).ready(function(){
// console.log("document is ready");
});
$(document).on('click', function(event) {
    console.log(event.target.className)
    // do stuff with ids and classes 
      /*  if(event.target.className.includes("cart-notification-wrapper")){
          $('.cart-notification-wrapper').remove();    
        }*/
    });

